/**
 * Decorative corner grip for a resizable dialog (ModalShell's `resizeGrips`).
 * Renders the six-dot "grab here" glyph mirrored for the left/right bottom
 * corners. Purely presentational: the drag belongs to the dialog.
 */
export function ResizeGlyph({ corner }: { corner: 'left' | 'right' }) {
  const dotClass = 'absolute h-0.5 w-0.5 rounded-full bg-[color:var(--border-strong)]'
  const dots =
    corner === 'right'
      ? [
          ['right-[4px]', 'bottom-[12px]'],
          ['right-[4px]', 'bottom-[8px]'],
          ['right-[8px]', 'bottom-[8px]'],
          ['right-[4px]', 'bottom-[4px]'],
          ['right-[8px]', 'bottom-[4px]'],
          ['right-[12px]', 'bottom-[4px]'],
        ]
      : [
          ['left-[4px]', 'bottom-[12px]'],
          ['left-[4px]', 'bottom-[8px]'],
          ['left-[8px]', 'bottom-[8px]'],
          ['left-[4px]', 'bottom-[4px]'],
          ['left-[8px]', 'bottom-[4px]'],
          ['left-[12px]', 'bottom-[4px]'],
        ]

  return (
    <div className="pointer-events-none absolute inset-0">
      {dots.map(([xClass, yClass]) => (
        <span key={`${xClass}-${yClass}`} className={`${dotClass} ${xClass} ${yClass}`} />
      ))}
    </div>
  )
}
